import React from 'react';
import { useFamily } from '../contexts/FamilyContext';
import { UserCircle } from 'lucide-react';

export default function ProfileSelector() {
    const { familyData, activeProfileId, setActiveProfileId } = useFamily();

    if (!familyData?.members) return null;

    const activeMember = familyData.members.find(m => m.id === activeProfileId);

    return (
        <div className="flex items-center gap-2 bg-slate-800 rounded-full px-3 py-1 border border-slate-700">
            <UserCircle className="h-4 w-4 text-blue-400" />
            <span className="text-slate-400 text-sm hidden sm:inline">Tracking for:</span>
            <select
                value={activeProfileId || ''}
                onChange={(e) => setActiveProfileId(e.target.value)}
                className="bg-transparent text-white font-medium text-sm focus:outline-none cursor-pointer"
            >
                {familyData.members.map(member => (
                    <option key={member.id} value={member.id} className="bg-slate-800 text-white">
                        {member.name}
                    </option>
                ))}
            </select>
        </div>
    );
}
